._dividerContent_10t6i_1 {
  margin-left: 0;
  margin-right: auto;
  width: -webkit-fit-content;
  width: -moz-fit-content;
  width: fit-content; }
  ._dividerContent_10t6i_1 span {
    font-size: 10px;
    font-style: normal;
    font-weight: 700;
    line-height: 12px;
    text-transform: uppercase; }

._dividerWrapper_10t6i_12 {
  margin: 6px 0px; }

._contextMenuActionWrapper_10t6i_15 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 6px; }

._MenuDeprecationNotificationBanner_10t6i_21 {
  width: 272px;
  margin: 8px 8px 0px 8px; }
